import { defineProperty as _defineProperty } from '../../_virtual/_rollupPluginBabelHelpers.js';
import React from 'react';
import { cleanupClassObject } from '../../utils/DomUtils.js';
import { texts } from '../../utils/Localization.js';
import { fComp } from '../../utils/React.js';
import { FooterPresentation } from '../Footer/FooterPresentation.js';
import { HeadlinePresentation } from '../Headline/HeadlinePresentation.js';
import { LogoPresentation } from '../Logo/LogoPresentation.js';
import { NavigationBarPresentation } from '../NavigationBar/NavigationBarPresentation.js';
import { hostClass } from './SimpleFooter.styles.js';

var defaultProps = {};
var SimpleFooterPresentation = fComp(function (props) {
  var _cleanupClassObject, _cleanupClassObject2, _cleanupClassObject3, _cleanupClassObject4;

  var id = props.id,
      className = props.className,
      noMargin = props.noMargin,
      isStencilHost = props.isStencilHost,
      contactModule = props.contactModule,
      navigationTree = props.navigationTree,
      logoDisabled = props.logoDisabled,
      logoAlt = props.logoAlt,
      logoHref = props.logoHref,
      logoSrc = props.logoSrc,
      logoHtmlAttrs = props.logoHtmlAttrs,
      onLogoClick = props.onLogoClick,
      claim = props.claim;
  return /*#__PURE__*/React.createElement(FooterPresentation, {
    id: id,
    className: cleanupClassObject((_cleanupClassObject = {}, _defineProperty(_cleanupClassObject, className, !!className), _defineProperty(_cleanupClassObject, hostClass, true), _cleanupClassObject)),
    isStencilHost: isStencilHost,
    noMargin: noMargin,
    contactArea: contactModule
  }, /*#__PURE__*/React.createElement("div", {
    className: "".concat(hostClass, "-brandbar")
  }, /*#__PURE__*/React.createElement("div", {
    className: cleanupClassObject((_cleanupClassObject2 = {}, _defineProperty(_cleanupClassObject2, "".concat(hostClass, "-brandbar-item"), true), _defineProperty(_cleanupClassObject2, "".concat(hostClass, "-brandbar-item-logo"), true), _cleanupClassObject2))
  }, /*#__PURE__*/React.createElement(LogoPresentation, {
    className: "".concat(hostClass, "-logo"),
    variant: "vertical",
    isMonochrome: true,
    noMargin: true,
    href: logoHref,
    disabled: logoDisabled,
    alt: logoAlt,
    srcCustom: logoSrc,
    onClick: onLogoClick,
    htmlAttrs: Object.assign({
      "aria-label": texts.lsg.component.Logo.actionHome
    }, logoHtmlAttrs)
  })), /*#__PURE__*/React.createElement("div", {
    className: cleanupClassObject((_cleanupClassObject3 = {}, _defineProperty(_cleanupClassObject3, "".concat(hostClass, "-brandbar-item"), true), _defineProperty(_cleanupClassObject3, "".concat(hostClass, "-brandbar-item-claim"), true), _cleanupClassObject3))
  }, /*#__PURE__*/React.createElement(HeadlinePresentation, {
    size: "h6",
    className: "".concat(hostClass, "-claim"),
    noMargin: true
  }, claim || texts.lsg.component.Footer.claim)), /*#__PURE__*/React.createElement("div", {
    className: cleanupClassObject((_cleanupClassObject4 = {}, _defineProperty(_cleanupClassObject4, "".concat(hostClass, "-brandbar-item"), true), _defineProperty(_cleanupClassObject4, "".concat(hostClass, "-brandbar-item-metabar"), true), _cleanupClassObject4))
  }, /*#__PURE__*/React.createElement(NavigationBarPresentation, {
    navigationTree: navigationTree,
    value: "",
    size: "meta-bar"
  }))));
}, defaultProps);

export { SimpleFooterPresentation, defaultProps };
